import React from 'react';

interface TabTitleArgs {
  title: string;
  count: number | string;
  color: 'green' | 'gray';
}

const TabTitleWithPills = ({ title, count, color }: TabTitleArgs) => (
  <div className="position-relative">
    <span>{title}</span>
    <div
      className={`text-pill ${color}-pill d-inline-block position-relative ms-2`}
    >
      <span>{count}</span>
    </div>
  </div>
);

const TabTitle = ({ title }: { title: string }) => (
  <div className="position-relative">
    <span>{title}</span>
  </div>
);
export { TabTitle, TabTitleWithPills };
